import { takeEvery, put, call, all, fork } from "@redux-saga/core/effects";
import { FETCH_USERS, SET_USERS } from "redux/constants/flowDesigner";
import { fetchUsers } from "api/UsersApi";

/***** WORKERS *****/

function* handleFetchUsers({ payload }) {
   try {
      const { tenant_id } = payload;
      const usersResponse = yield call(fetchUsers, tenant_id);
      if (usersResponse) {
         const filteredUsers = usersResponse.filter((user) => user.email_address);
         yield put({ type: SET_USERS, payload: filteredUsers });
      }
   } catch (error) {
      console.error(error);
   }
}

/***** WATCHERS *****/

function* watchFetchUsers() {
   yield takeEvery(FETCH_USERS, handleFetchUsers);
}
export function* rootUsersSaga() {
   yield all([fork(watchFetchUsers)]);
}
